import { useCallback, useEffect, useState } from 'react';

import { LDContext, useLDClient } from 'launchdarkly-react-client-sdk';

import { HomeUserSessionData } from '@liscio/api';
import { firmCreatedAt } from '@liscio/common';

import { config } from '../config';

export const mapHomeDataToContext = (data: HomeUserSessionData): LDContext => ({
  kind: 'multi',
  app: {
    key: '@liscio/firm',
  },
  platform: {
    key: config.platform,
  },
  firm: {
    key: data.company_url,
    url: data.company_url,
    name: data.cpa_name,
    id: data.cpa_id,
    ...firmCreatedAt(data.cpa_created_at),
  },
  role: {
    key: data.role,
  },
});

/**
 * Helper hook for updating launchdarkly context from home data
 */
export const useLaunchDarklyIdentify = () => {
  const ldClient = useLDClient();
  const [homeData, setHomeData] = useState<HomeUserSessionData | null>(null);

  const identify = useCallback(async (data: HomeUserSessionData) => {
    setHomeData(data);
  }, []);

  useEffect(() => {
    if (homeData && ldClient) {
      const context = mapHomeDataToContext(homeData);
      ldClient.identify(context);
    }
  }, [homeData, ldClient]);

  return { identify };
};
